import React from 'react';

import {
  VideoTutorielDto,
  VideoTutorielViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { buildDefaultUpdateFormValues, buildDto } from '../utils/mappers';
import { VideoFormValue } from '../utils/type';

import ModalEdition from './ModalEdition';

interface ModalUpdateProps {
  video: VideoTutorielDto;
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalUpdate({
  video,
  close,
  visible,
  refreshDashboard,
}: ModalUpdateProps): React.ReactElement {
  const initials: VideoFormValue = buildDefaultUpdateFormValues(video);
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: VideoFormValue) =>
      AdminFonctionnelControllerApi.updateVideoTutorielUsingPUT(
        video.idCorrelation,
        buildDto(values),
      ),
  );

  const { validate } = useValidateReferentielForm(
    (field: VideoTutorielViolationDtoFormFieldEnum, values: VideoFormValue) =>
      AdminFonctionnelControllerApi.validateUpdateVideoTutorielFieldUsingPOST(
        field,
        video.idCorrelation,
        buildDto(values),
      ),
    response => response.videoTutorielViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Mise à jour de la vidéo"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
